import { render } from "./AltaTipsterForm.vue?vue&type=template&id=128841c1&scoped=true"
import script from "./AltaTipsterForm.vue?vue&type=script&lang=js"
export * from "./AltaTipsterForm.vue?vue&type=script&lang=js"

import "./AltaTipsterForm.vue?vue&type=style&index=0&id=128841c1&scoped=true&lang=css"

import exportComponent from "/var/www/html/quanty/quanty-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-128841c1"]])

export default __exports__